/* Tice Nits: blogartikel. Gewone JavaScript, geen bibliotheken.
   1. Tekst opschonen: lege koppen en alinea's weg, tabellen scrollbaar, afbeeldingen zonder alt als decoratief markeren.
   2. Inhoudstafel uit de H2's (vanaf vier kopjes).
   3. Link kopiëren. */
(function () {
  'use strict';

  function slug(text, used) {
    var s = text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'kop';
    var out = s, n = 2;
    while (used[out] || document.getElementById(out)) { out = s + '-' + n++; }
    used[out] = true;
    return out;
  }

  function clean(body) {
    body.querySelectorAll('h2, h3, h4, p, div').forEach(function (el) {
      if (el.querySelector('img, iframe, video, table')) { return; }
      var t = el.textContent.replace(/[\s ]+/g, '');
      if (t === '' && (el.tagName === 'H2' || el.tagName === 'H3' || el.tagName === 'H4')) { el.remove(); }
      else if (t === '' && el.tagName === 'P' && el.children.length === 0) { el.remove(); }
    });
    body.querySelectorAll('img').forEach(function (img) {
      if (!img.hasAttribute('alt')) { img.setAttribute('alt', ''); }
    });
    body.querySelectorAll('table').forEach(function (tbl) {
      if (tbl.parentElement && tbl.parentElement.classList.contains('tnb-table')) { return; }
      var wrap = document.createElement('div');
      wrap.className = 'tnb-table';
      tbl.parentNode.insertBefore(wrap, tbl);
      wrap.appendChild(tbl);
    });
    body.querySelectorAll('a[href^="http"]').forEach(function (a) {
      try {
        if (new URL(a.href).host.replace(/^www\./, '') !== location.host.replace(/^www\./, '')) {
          a.setAttribute('rel', 'noopener');
        }
      } catch (e) { /* ongeldige url: laten staan */ }
    });
  }

  function toc(body, nav) {
    if (!nav) { return; }
    var heads = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) {
      return h.textContent.trim().length > 0;
    });
    if (heads.length < 4) { return; }
    var used = {};
    var title = nav.getAttribute('data-title');
    var html = '';
    heads.forEach(function (h) {
      if (!h.id) { h.id = slug(h.textContent, used); }
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      html += '<li>' + a.outerHTML + '</li>';
    });
    nav.innerHTML = (title ? '<p class="tnb-toc__t">' + title.replace(/[<>&]/g, '') + '</p>' : '') + '<ol>' + html + '</ol>';
    if (title) { nav.setAttribute('aria-label', title); }
    nav.hidden = false;
  }

  function share(root) {
    var btn = root.querySelector('[data-tnb-copy]');
    var live = root.querySelector('[data-tnb-live]');
    if (!btn) { return; }
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-tnb-copy');
      var done = function () { if (live) { live.textContent = btn.getAttribute('data-done') || ''; setTimeout(function () { live.textContent = ''; }, 3000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      } else {
        window.prompt('', url);
      }
    });
  }

  function init() {
    var body = document.querySelector('[data-tnb-body]');
    if (!body) { return; }
    clean(body);
    toc(body, document.querySelector('[data-tnb-toc]'));
    var sh = document.querySelector('[data-tnb-share]');
    if (sh) { share(sh); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
